import { render, staticRenderFns } from "./ShopBoxSearchBarComponent.vue?vue&type=template&id=33b9315d&scoped=true"
import script from "./ShopBoxSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./ShopBoxSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopBoxSearchBarComponent.vue?vue&type=style&index=0&id=33b9315d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b9315d",
  null
  
)

export default component.exports